import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  // Uses the apiUrl defined in environment.ts
  private apiUrl1 = environment.apiUrl1;

  constructor(private http: HttpClient) { }

  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    if (error.error instanceof ProgressEvent) {
      console.error('Network error or CORS issue');
      return throwError(() => new Error('Network error. Please check your connection.'));
    }

    if (typeof error.error === 'string' && error.error.includes('<!doctype')) {
      console.error('Received HTML instead of JSON - API endpoint might be incorrect');
      return throwError(() => new Error('Server configuration error. Please contact support.'));
    }

    return throwError(() => new Error(error.error?.Message || 'Something went wrong; please try again later.'));
  }

  sendWhitepaperEmail(data: { Name: string; Email: string; WhitepaperTitle: string }): Observable<any> {
    // Make sure the URL matches exactly
    const url = `${this.apiUrl1}Email/SendEmailForWhitepaperDownload`;

    console.log('Calling API:', url);
    console.log('Payload:', data);

    return this.http.post(url, data, {
      headers: { 'Content-Type': 'application/json' }
    }).pipe(
      catchError(this.handleError)
    );
  }
  sendTechGeekEmail(data: { Name: string; Email: string; TechGeekTitle: string }): Observable<any> {

    const url = `${this.apiUrl1}Email/SendEmailForTechGeekDownload`;

    console.log('Calling API:', url);
    console.log('Payload:', data);
    
    return this.http.post(url, data, {
      headers: { 'Content-Type': 'application/json' }
    }).pipe(
      catchError(this.handleError)
    );
  }
}